"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DateAsString = void 0;
const runtypes_1 = require("runtypes");
// todo switch to latest version of runtypes when this PR is merged and released
// https://github.com/pelotom/runtypes/pull/191
exports.DateAsString = runtypes_1.String.withConstraint((dateAsString) => !isNaN(Date.parse(dateAsString)));
